import { Box, FlexLayout, GridLayout } from '@deity/falcon-ui';
import { mapRecordToArray } from '@deity-io/di-data-basics';
import type { IRestEndpointConfig } from '@deity-io/di-data-flows';
import { mergeEndpointAndService } from '@deity-io/di-data-flows-editor';
import type { FC } from 'react';

interface IEndpointDetails {
  locked?: boolean;
  schema: Partial<IRestEndpointConfig>;
  service: Partial<IRestEndpointConfig>;
}

const EndpointDetails: FC<IEndpointDetails> = ({ locked = false, schema, service }) => {
  if (!schema) {
    return null;
  }
  const mergedSchema = mergeEndpointAndService(schema, service);
  const vars = mergedSchema.variables ? mapRecordToArray(mergedSchema.variables, (item, key) => `${key}=${item}`) : [];
  const path = vars.length ? `${mergedSchema.path}?${vars.join('&')}` : `${mergedSchema.path}`;

  return (
    <FlexLayout width="full">
      <GridLayout gridTemplateColumns="1fr 1fr" width="full">
        <Box>{mergedSchema.method}</Box>
        <Box>{`${mergedSchema.protocol}://${mergedSchema.host}`}</Box>
        <Box>Path</Box>
        <Box css={{ wordWrap: 'break-word' }}>{path}</Box>
      </GridLayout>
    </FlexLayout>
  );
};

export default EndpointDetails;
